var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 25",
    style: {
      enableBackground: "new 0 0 26 25"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#484848;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,8v9.4c0,0.6-0.5,1.1-1.1,1.1H7.7c-0.6,0-1.1-0.5-1.1-1.1V8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,8.6l8.2-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,18.3v-6.5c0-0.5,0.4-0.9,0.8-0.9h2.2c0.4,0,0.8,0.4,0.8,0.9v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,4.3L21.3,9"
  }))));
}

export default SvgRemote;